import React from "react"
import { Box, Button as MUIButton, Hidden, Divider } from "@mui/material"
import { withStyles } from "makeStyles"

import Menu, { MenuProps } from "@mui/material/Menu"
import Button from "components/Buttons/Button"

import Icon from "@mdi/react"
import { mdiMenuDown, mdiChevronRight, mdiTune } from "@mdi/js"

import useToggle from "@secureo/common/hooks/useToggle"

const StyledMenu = withStyles(
	(props: MenuProps) => (
		<Menu
			elevation={0}
			// getContentAnchorEl={null}
			anchorOrigin={{
				vertical: "bottom",
				horizontal: "left",
			}}
			transformOrigin={{
				vertical: "top",
				horizontal: "left",
			}}
			{...props}
		/>
	),
	() => ({
		paper: {
			border: "1px solid #d3d4d5",
			paddingLeft: 20,
			paddingRight: 20,
			paddingTop: 10,
			paddingBottom: 10,
			marginTop: 2,
			borderRadius: 5,
			boxShadow: "0px 3px 10px 0px rgba(0,0,0,0.15)",
		},
	}),
)

const FilterWrapper = ({ title, /* hint,*/ children }: Props) => {
	const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)
	const [open, toggleIsOpen] = useToggle()

	const handleClick = (event: React.MouseEvent<HTMLElement>) => {
		setAnchorEl(event.currentTarget)
	}

	const handleClose = () => {
		setAnchorEl(null)
	}

	return (
		<>
			<Hidden lgDown>
				<MUIButton
					aria-controls="customized-menu"
					aria-haspopup="true"
					variant="contained"
					color="primary"
					onClick={handleClick}
					style={{
						border: "1px solid rgba(115, 122, 128, 0.4)",
						borderRadius: 20,
						paddingLeft: 15,
						paddingRight: 15,
						background: "white",
						color: "#505e5f",
						boxShadow: "none",
						marginRight: 10,
						marginBottom: 10,
						textTransform: "inherit",
					}}
				>
					{title} <Icon path={mdiMenuDown} size={1} color="#505e5f" />
				</MUIButton>
				<StyledMenu
					id="customized-menu"
					anchorEl={anchorEl}
					keepMounted
					open={Boolean(anchorEl)}
					onClose={handleClose}
				>
					{children}
				</StyledMenu>
			</Hidden>
			{/* Mobile Filters (Drawer) */}
			<Hidden mdUp>
				<Box p={1}>
					<MUIButton
						onClick={toggleIsOpen}
						style={{ width: "100%", display: "flex", justifyContent: "space-between" }}
					>
						{title}
						<Icon path={mdiChevronRight} size={1} color="black" />
					</MUIButton>
				</Box>
				{open && (
					<div
						style={{
							height: "100%",
							width: "100%",
							position: "fixed",
							zIndex: 9999,
							top: 0,
							left: 0,
							background: "white",
						}}
					>
						<Box
							py={1}
							style={{
								background: "#E7EFF6",
								color: "#263739",
								display: "flex",
								justifyContent: "center",
								alignItems: "center",
							}}
						>
							<Icon path={mdiTune} size={1} color="#263739" />
							<Box ml={1}>
								<strong>{title}</strong>
							</Box>
						</Box>
						<Box px={2} pt={2} style={{ minWidth: 260, maxWidth: 270 }}>
							{children}
						</Box>
						<div
							style={{
								left: "50%",
								transform: "translateX(-50%)",
								position: "absolute",
								bottom: 50,
								width: 200,
							}}
						>
							<Button color="secondary" onClick={toggleIsOpen}>
								Zurück
							</Button>
						</div>
					</div>
				)}

				<Box mx={1}>
					<Divider />
				</Box>
			</Hidden>
		</>
	)
}

interface Props {
	title: string
	omitWrapper?: boolean
	children: React.ReactNode
	hint?: string
}

export default FilterWrapper
